import type { PropsWithChildren } from 'react';
import type { GetCustomWorklistsQuery, GetCustomWorklistsQueryVariables } from 'generated/graphql';
import { useCurrentUser } from 'hooks/useCurrentUser';
import { createContextedQuery } from 'modules/Apollo/createContextedQuery';
import { GET_CUSTOM_WORKLISTS } from 'modules/Apollo/queries';
import type { WithApolloContext } from 'modules/Apollo/types';

const { Provider: CustomWorklistsQueryOwner, useQuery: useCustomWorklistsQuery } =
  createContextedQuery<GetCustomWorklistsQuery, GetCustomWorklistsQueryVariables>(
    GET_CUSTOM_WORKLISTS,
    { name: 'CustomWorklistsQuery' }
  );

export const CustomWorklistsQueryProvider = ({
  children,
  context,
  skip = false,
}: PropsWithChildren<WithApolloContext & { skip?: boolean }>): React.ReactElement => {
  const { data } = useCurrentUser({ context });
  const userSmid = data?.me?.id ?? '';

  return (
    <CustomWorklistsQueryOwner
      options={{
        variables: { userSmid },
        skip: skip || userSmid.length === 0,
        context,
      }}
    >
      {children}
    </CustomWorklistsQueryOwner>
  );
};

export { useCustomWorklistsQuery };
